import { useMocks } from '../../shared/env';
import type { ReportsGateway } from './ReportsGateway';
import { HttpReportsGateway } from './HttpReportsGateway';
import { MockReportsGateway } from './MockReportsGateway';

export const reportsGateway: ReportsGateway = useMocks ? new MockReportsGateway() : new HttpReportsGateway();
export type { ReportsGateway } from './ReportsGateway';
